// src/features/executive/performance/usedStyle.tsx
import { Box, styled } from '@mui/material'

export const TabRoot = styled(Box)(({ theme }) => ({
  paddingTop: theme.spacing(3),
  paddingBottom: theme.spacing(3),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4),  // larger gap between sections vs within sections
}))

// Section = header + one or more rows. Tight internal gap so the header
// stays visually anchored to its content.
export const Section = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1.5),
}))

// 4-col KPI hero row (Revenue / AvgBill / AvgRevenue / Patient summary).
export const HeroRow = styled(Box)(({ theme }) => ({
  display: 'grid',
  gap: theme.spacing(2),
  gridTemplateColumns: '1fr',
  alignItems: 'stretch',
  [theme.breakpoints.up('sm')]: { gridTemplateColumns: 'repeat(2, 1fr)' },
  [theme.breakpoints.up('md')]: { gridTemplateColumns: 'repeat(4, 1fr)' },
}))

// 2-col detail row — KeyProcedures (2fr) + Appointments (1fr).
export const DetailRow = styled(Box)(({ theme }) => ({
  display: 'grid',
  gap: theme.spacing(2),
  gridTemplateColumns: '1fr',
  alignItems: 'stretch',
  [theme.breakpoints.up('md')]: { gridTemplateColumns: '2fr 1fr' },
}))

// Generic full-width row container (used for RevenueTrend, PerBranch).
export const FullRow = styled(Box)({
  display: 'block',
})
